export default "__VITE_ASSET__DjSIvRY7__"